import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  },

  icons: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.paper,

    '&:not(:first-of-type)': {
      marginLeft: theme.spacing(-2.5),
    },
  },
}));
